export const TICKETURE_EXTERNAL_MUSIC_EVENT_CATEGORY = 'MUSIC_EXT'
export const TICKETURE_ADD_ON_EVENT_CATEGORY = 'Add-on'
